<app-header></app-header>

<app-spinner></app-spinner>

<router-outlet></router-outlet>